<template>
    <div>
        <validation-observer ref="toggleForm">
            <div :class="{'form-group': isPopUp, 'p-0-1':  'p-0-14'}">
                <label  :class="{' col-md-3 col-xs-4' : isInquiry , 'attribute-label' : !isInquiry}">
                    {{ question.question_text }}

                </label>
                <div class="toggle-attribute" :class="{' col-md-9 col-xs-8 ' : isInquiry}">
                    <label class="figma-switch">
                        <input :id="id"
                               :name="name"
                               v-model="question.value"
                               type="checkbox"
                               @click="changeToggleValue">
                        <span class="slider round" for="toggle-attribute"> </span>
                    </label>
                    <input type="hidden" :value="id" name="questions[]">
                    <image-uploader v-if="question.show_answer_photo" :question="question"></image-uploader>
                </div>
<!--                <validation-provider v-slot="{errors}" :rules="attribute.mandatory ? 'required' : ''">-->
<!--                    <div v-if="selected && selected.hasOwnProperty('attribute_value_id')" class="display-none">-->
<!--                        <input :id="id" :name="name" :value="selected.attribute_value === 'Yes'? 1 : 0"-->
<!--                               type="hidden">-->
<!--                    </div>-->
<!--                    <span v-if="errors && errors.length" class="text text-danger error-label">{{ errors[0] }}</span>-->
<!--                </validation-provider>-->
            </div>
        </validation-observer>

    </div>
</template>

<script>
import {ValidationObserver, ValidationProvider} from "vee-validate";
import {EventBus} from "@/events/event-bus";
import ImageUploader from "@/modules/common/components/ImageUploader";
import {updateFormQuestionOnViewInquiry} from "../../../../events/sharedMethods";

export default {
    name: "FormToggle",
    props: {
        value: {},
        isPopUp:false,
        viewPage:false,
        isInquiry:false,
        inquiryId:0
    },
    data() {
        return {
            question: this.value,
            selected: this.value.answer_text_names === 'on'
        }
    },
    components: {
        ImageUploader,
        ValidationObserver,
        ValidationProvider
    },
    computed: {
        /**
         * get attribute input id
         * @returns {string}
         */
        id() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        },
        /**
         * get attribute input name
         * @returns {string}
         */
        name() {
            if(this.isInquiry){
                return `attribute_${this.question.attribute_id}`;
            }
            return `question_${this.question.update_booking_question_id}_0`;
        }
    },
    methods: {

        addEventListeners() {
            EventBus.$on('onFormsAndCheckListsValidation', async (verify) => {
                if(this.$refs.toggleForm) {
                    let validated = await this.$refs.toggleForm.validate();
                    verify(validated)
                }
            })
        },
        removeEventListeners(){
            EventBus.$off('onFormsAndCheckListsValidation');
        },
        /**
         * pick a value
         * @param value
         */
        changeToggleValue(value) {

           this.selected = !this.selected;
            if(this.viewPage && this.isInquiry){
                updateFormQuestionOnViewInquiry(this.selected, this.inquiryId, this.question.inquiry_type_attribute_id, this.question.attribute_id);
            }

        },

    },
    mounted() {
        this.addEventListeners();
    },
    watch: {
        question: {
            handler(question) {
                this.$emit('input', question)
            },
            deep: true
        }
    },
    destroyed() {
        this.removeEventListeners();
    }
}
</script>

<style scoped>
.selected {
    font-weight: bold;
}
.p-0-1{
    padding:0px 1px;
}
</style>